import MarketingFooter from '@/layers/presentation/components/common/MarketingFooter';
import MarketingNavbar from '@/layers/presentation/components/common/MarketingNavbar';
import MarketingOnboardingBanner from '@/layers/presentation/components/common/MarketingOnboardingBanner';

export interface MarketingMainLayoutProps {
  children: React.ReactNode;
  navbar?: {
    variant: 'default' | 'transparent' | 'dark';
  };
}

export default function MarketingMainLayout({
  children,
  navbar = { variant: 'default' },
}: MarketingMainLayoutProps) {
  return (
    <div className="flex flex-col min-h-screen">
      <MarketingOnboardingBanner type="top" />
      <MarketingNavbar variant={navbar.variant} />
      <div className="flex flex-grow w-full mx-auto">
        <div className="main w-full">{children}</div>
      </div>
      <MarketingFooter />
    </div>
  );
}
